import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=b6bfeb84&scoped=true&"
import script from "./LoginView.vue?vue&type=script&lang=ts&"
export * from "./LoginView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bfeb84",
  null
  
)

export default component.exports